import React from 'react';
import { useDispatch, useSelector }         from 'react-redux'
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

import { selectAssemblyLoading } from '../selector/selector';

export default (props) => {
  const {
    loading,
  } = useSelector(selectAssemblyLoading)

  const clazz = classnames({
    'pcb-loading-overlay': true,
    hidden: !loading,
  });

  return (
    <div className={clazz}>
      <div className="spin">
        <FontAwesomeIcon icon={faSync} spin />
      </div>
    </div>
  );
};
